import type { WizardState, WizardAction } from './types';

export function createInitialWizardState(
  initialMeta?: Record<string, unknown>,
): WizardState {
  return {
    phase: 'idle',
    currentStepIndex: 0,
    meta: initialMeta ? { ...initialMeta } : {},
    stepData: {},
    error: null,
    visitedSteps: [],
  };
}

export function wizardReducer(
  state: WizardState,
  action: WizardAction,
): WizardState {
  switch (action.type) {
    case 'SCHEMA_LOADED':
      return { ...state, phase: 'ready' };

    case 'SCHEMA_ERROR':
      return {
        ...state,
        phase: 'error',
        error: {
          phase: state.phase,
          message: action.message,
          recoverable: false,
        },
      };

    case 'ACTIVATE_STEP': {
      const visitedSteps = state.visitedSteps.includes(
        String(action.index),
      )
        ? state.visitedSteps
        : [...state.visitedSteps, String(action.index)];
      return {
        ...state,
        phase: 'step_active',
        currentStepIndex: action.index,
        error: null,
        visitedSteps,
      };
    }

    case 'CHANNEL_READY':
      return { ...state, phase: 'step_ready' };

    case 'HANDLER_STARTED':
      return { ...state, phase: 'handler_running' };

    case 'HANDLER_COMPLETED':
      return { ...state, phase: 'step_ready' };

    case 'UPDATE_META':
      return { ...state, meta: { ...state.meta, ...action.updates } };

    case 'SET_STEP_DATA':
      return {
        ...state,
        stepData: {
          ...state.stepData,
          [action.stepId]: action.data,
        },
      };

    case 'START_COMPLETING':
      return { ...state, phase: 'completing' };

    case 'COMPLETED':
      return { ...state, phase: 'complete' };

    case 'START_CANCELLING':
      return { ...state, phase: 'cancelling' };

    case 'CANCELLED':
      return { ...state, phase: 'complete' };

    case 'SET_ERROR':
      return { ...state, phase: 'error', error: action.error };

    case 'CLEAR_ERROR':
      return { ...state, phase: 'step_ready', error: null };

    case 'RESET':
      return createInitialWizardState(state.meta);
  }
}
